const { signupServiceUrl, mode } = window.siteInfo || {};

export const SIGNUP_SERVICE_URL = signupServiceUrl;

export const LEAD_REGISTRATION_API = `${SIGNUP_SERVICE_URL}/services/leadRegistration`;

export const ADD_NOTE_TO_LEAD_API = `${SIGNUP_SERVICE_URL}/services/addNoteToLead`;

export const DS_URL = mode === 'live' ? 'https://my.distributedsource.com/crm' : 'https://mystaging.distributedsource.com/crm';

export const INQUIRY_MAIL_API = `${SIGNUP_SERVICE_URL}/services/sendInquiryMail`;

export const BRANDID = '9c01c4a2-e055-4342-8589-2e5bd632524c';

export const BRAND_NAME = 'Branding-WellReceived-Website';

export const UPDATE_CONTACT_API = `${SIGNUP_SERVICE_URL}/services/updateContact`;
export const COMPANY_CONTACT_UPDATE_API = `${SIGNUP_SERVICE_URL}/services/updateCompanyContact`;
export const isLive = mode === 'live';
